import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { usePlanAccess } from "../../hooks/usePlanAccess";

export const FreeScanMeter = () => {
  const sub = usePlanAccess();
  const navigate = useNavigate();
  const usage = sub?.pic_to_lead_usage;
  if (!usage || usage.limit == null) return null;
  const out = usage.remaining <= 0;
  return (
    <div data-testid="pic-free-meter" style={{
      display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12,
      background: out ? "#fef2f2" : "#eff6ff", border: `1px solid ${out ? "#fecaca" : "#bfdbfe"}`,
      borderRadius: 12, padding: "12px 16px", marginBottom: 16,
    }}>
      <span style={{ fontSize: 14, fontWeight: 600, color: out ? "#b91c1c" : "#1d4ed8" }} data-testid="pic-free-remaining">
        {out
          ? `You've used all ${usage.limit} free card scans this month.`
          : `Free plan: ${usage.remaining} of ${usage.limit} card scans left this month.`}
      </span>
      <Button size="sm" onClick={() => navigate("/plans")} data-testid="pic-upgrade-btn">
        <Sparkles size={14} style={{ marginRight: 6 }} /> Go unlimited with Basic
      </Button>
    </div>
  );
};
